import {
  Autocomplete,
  Button,
  Grid,
  Paper,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import moment from "moment";

/**
 *
 */
const CollectionType = [
  { id: 1, label: "Fosă vidanjabilă" },
  { id: 2, label: "Betonată/Nebetonată" },
  { id: 3, label: "Tuburi" },
  { id: 4, label: "Fosă profesională" },
];
/**
 *
 */
const EvacuationType = [
  { id: 1, label: "Direct" },
  { id: 2, label: "Indirect" },
];
function ReportFilters({ filters, streets, setFilters, applyFilters }) {
  const matches = useMediaQuery("(max-width:800px)");
  const notifyError = (message) => toast.error(message);
  const navigate = useNavigate();

  /**
   *
   * @param {*} event
   * @returns
   */
  function handleChangeStartDate(event) {
    let newFilters = Object.assign({}, filters);
    if (moment(event.$d).isAfter(filters.endDate)) {
      notifyError(
        "Data este invalidă! Nu puteți alege data de start după data de stop."
      );
      return;
    }
    newFilters.startDate = moment(event.$d);
    setFilters(newFilters);
  }

  /**
   *
   * @param {*} event
   * @returns
   */
  function handleChangeEndDate(event) {
    let newFilters = Object.assign({}, filters);
    if (moment(event.$d).isAfter(moment())) {
      notifyError(
        "Data este invalidă! Nu puteți alege data de stop după data actuală."
      );
      return;
    }
    if (moment(event.$d).isBefore(filters.startDate)) {
      notifyError(
        "Data este invalidă! Nu puteți alege data de stop înaintea datei de start."
      );
      return;
    }
    newFilters.endDate = moment(event.$d);
    setFilters(newFilters);
  }

  /**
   *
   * @param {*} event
   */
  function handleChangeFilters(event) {
    let newFilters = Object.assign({}, filters);
    newFilters[event.target.name] = event.target.value;
    setFilters(newFilters);
  }

  /**
   *
   * @param {*} event
   * @param {*} newValue
   */
  function handleChangeCollectionType(event, newValue) {
    let newFilters = Object.assign({}, filters);
    if (newValue) newFilters.collectionType = newValue;
    else if (event.target.value) {
      newFilters.collectionType = {
        id: 5,
        label: event.target.value,
      };
    } else
      newFilters.collectionType = {
        id: "",
        label: "",
      };
    setFilters(newFilters);
  }

  /**
   *
   * @param {*} event
   * @param {*} newValue
   */
  function handleChangeStreet(event, newValue) {
    let newFilters = Object.assign({}, filters);
    if (newValue) newFilters.street = newValue;
    else if (event.target.value) {
      newFilters.street = {
        id: 5,
        label: event.target.value,
      };
    } else
      newFilters.street = {
        id: "",
        label: "",
      };
    setFilters(newFilters);
  }

  /**
   *
   * @param {*} event
   * @param {*} newValue
   */
  function handleChangeEvacuationType(event, newValue) {
    let newFilters = Object.assign({}, filters);
    if (newValue) newFilters.evacuationType = newValue;
    else if (event.target.value) {
      newFilters.evacuationType = {
        id: 3,
        label: event.target.value,
      };
    } else
      newFilters.evacuationType = {
        id: "",
        label: "",
      };
    setFilters(newFilters);
  }

  /**
   *
   */
  function deleteFilters() {
    setFilters({
      startDate: moment().subtract(1, "month"),
      endDate: moment(),
      name: "",
      cnp_cif: "",
      street: "",
      number: "",
      collectionType: {
        id: "",
        label: "",
      },
      evacuationType: {
        id: "",
        label: "",
      },
    });
    navigate(
      `?startDate=${filters.startDate.format(
        "YYYY-MM-DD"
      )}?endDate=${filters.endDate.format("YYYY-MM-DD")}`
    );
  }

  return (
    <Paper style={{ margin: 20, padding: 20 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
              label="Data de start"
              inputFormat="DD-MM-YYYY"
              fullWidth
              value={filters.startDate}
              onChange={handleChangeStartDate}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  style={{ margin: "10px 0px" }}
                />
              )}
            />
          </LocalizationProvider>
          <TextField
            type="text"
            name="name"
            label="Nume"
            fullWidth
            value={filters.name}
            onChange={handleChangeFilters}
            style={{ margin: "10px 0px" }}
          />
          <Autocomplete
            id="street"
            name="street"
            options={streets}
            value={filters.street}
            freeSolo
            selectOnFocus
            handleHomeEndKeys
            renderInput={(params) => (
              <TextField
                {...params}
                label="Strada"
                style={{ margin: "10px 0px" }}
                onChange={(event, newValue) =>
                  handleChangeStreet(event, newValue)
                }
              />
            )}
            onChange={(event, newValue) => handleChangeStreet(event, newValue)}
          />
          <Autocomplete
            id="collecton"
            name="collectionType"
            options={CollectionType}
            value={filters.collectionType}
            freeSolo
            selectOnFocus
            handleHomeEndKeys
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tip colectare"
                style={{ margin: "10px 0px" }}
                onChange={(event, newValue) =>
                  handleChangeCollectionType(event, newValue)
                }
              />
            )}
            onChange={(event, newValue) =>
              handleChangeCollectionType(event, newValue)
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
              label="Data de stop"
              inputFormat="DD-MM-YYYY"
              fullWidth
              value={filters.endDate}
              onChange={handleChangeEndDate}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  style={{ margin: "10px 0px" }}
                />
              )}
            />
          </LocalizationProvider>
          <TextField
            type="number"
            name="cnp_cif"
            label="CNP/CIF"
            fullWidth
            value={filters.cnp_cif}
            onChange={handleChangeFilters}
            style={{ margin: "10px 0px" }}
          />
          <TextField
            type="text"
            name="number"
            label="Număr"
            fullWidth
            value={filters.number}
            onChange={handleChangeFilters}
            style={{ margin: "10px 0px" }}
          />

          <Autocomplete
            disablePortal
            id="evacuation"
            name="evacuationType"
            options={EvacuationType}
            value={filters.evacuationType}
            freeSolo
            selectOnFocus
            handleHomeEndKeys
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tip evacuare"
                onChange={(event, newValue) =>
                  handleChangeEvacuationType(event, newValue)
                }
              />
            )}
            onChange={(event, newValue) =>
              handleChangeEvacuationType(event, newValue)
            }
            style={{ margin: "10px 0px" }}
          />
        </Grid>
      </Grid>
      <div style={{ textAlign: "start", marginTop: 10 }}>
        <Button
          variant="contained"
          style={{ margin: "10px 30px 10px 0px" }}
          fullWidth={matches}
          onClick={() => applyFilters(filters)}
        >
          <FilterListIcon style={{ marginRight: 10 }} />
          APLICĂ FILTRELE
        </Button>
        <Button
          variant="contained"
          style={{ margin: "10px 10px 10px 0px" }}
          fullWidth={matches}
          onClick={deleteFilters}
        >
          <CloseIcon style={{ marginRight: 10 }} />
          ȘTERGE FILTRE
        </Button>
      </div>
      <ToastContainer />
    </Paper>
  );
}

export default ReportFilters;
ReportFilters.propTypes = {
  filters: PropTypes.object,
  streets: PropTypes.object,
  setFilters: PropTypes.func,
  applyFilters: PropTypes.func,
};
